export const APP_3in1 = "3in1";
export const APP_M1 = "M1";
export const APP_SRC = "src";
export const COMMON_SSO_ACCESS_TOKEN = "access_token";
export const WEB_LOGGED_IN = "Web-logged-in";
export const WEB_NON_LOGGED_IN = "Web-non-logged-in";
export const WEB_NON_LOGGED_IN_IDENTIFIED = "Web-non-logged-in-identified";
export const SOURCE = "website";
export const APP_URL_INDENTIFIER = "/app-v";
export const WEB_VIEW_MODE = "webViewMode";
export const WEB_VIEW_MODE_ON = "on";
export const INVESTMENT_BASE_PATH = "/investments/";
export const OPEN_IN_APP_HEADER = "x-open-in-app";
export const USER_DETAILS_COOKIE = "userDetails";

export const LoginConstants = {
  SUCCESS: "success",
  PERPETUAL: "perpetual",
  FAILURE: "failure",
  PENDING: "pending",
};
